import namespace  from './namespace';

export const SHOW_MODAL = namespace + '/SHOW_MODAL';
export const HIDE_MODAL= namespace + '/HIDE_MODAL';
